export default [
    {
        path: 'relatorio-estorno-dispensacao',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-estorno-dispensacao' */
            '@/views/farmacia/relatorio-estorno-dispensacao/Index'
        ),
        redirect: 'relatorio-estorno-dispensacao/index',
        children: [
            {
                name: 'farmacia-relatorio-estorno-dispensacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-estorno-dispensacao' */
                    '@/views/farmacia/relatorio-estorno-dispensacao/List'
                ),
            },
        ]
    }
]